import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { BalanceView } from './BalanceView';
import { WidgetLink } from './WidgetLink';
import { trackMixPanel } from '../../../services/mixpanel.service';

interface IBucketBalance {
  title: string;
  balance: number,
  testId: string,
  linkUrl: string;
  showSeparator?: boolean;
  mixpanelEventName?: string;
}
export const BucketBalance = ({
  title,
  balance,
  testId,
  linkUrl,
  showSeparator = false,
  mixpanelEventName,
}: IBucketBalance) => {
  const { t } = useTranslation();
  const handleOnClick = () => {
    if (mixpanelEventName) trackMixPanel(mixpanelEventName);
  };
  return (
    <div className='flex flex-wrap items-center'>
      <Heading title={title} className='font-metricR text-sm text-bw08 leading-5 mr-[5px]' testId={`${testId}_title`} />
      <BalanceView balance={balance} testId={`${testId}_amount`} />
      {showSeparator && <span className='border-[1px] w-[1px] h-[12px] border-bw05 mx-[5px] box-sizing' />}
      {!showSeparator && <span className='ml-[5px]' />}
      <WidgetLink
        linkTitle={t('WIDGETS_SHARED.MANAGE')}
        linkUrl={linkUrl}
        testId={`${testId}_manage-link`}
        onClick={handleOnClick}
      />
    </div>
  );
};
